import ptBR from './pt_BR.json'
import es from './es.json'
import en_US from './en_US.json'

export default {
  pt_BR: ptBR,
  es: es,
  en_US: en_US
}
